"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../global/components/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modules
// Components
var MakePaymentButton = function MakePaymentButton(props) {
  var clickHandler = props.clickHandler,
      isDisabled = props.isDisabled,
      _props$buttonText = props.buttonText,
      buttonText = _props$buttonText === void 0 ? '' : _props$buttonText;

  var handleClick = function handleClick() {
    if (isDisabled) return;
    clickHandler();
  };

  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    text: buttonText ? buttonText : "Make payment \u2192",
    clickHandler: handleClick,
    isDisabled: isDisabled,
    extraStyles: {
      width: '100%',
      paddingTop: '20px',
      paddingBottom: '20px'
    }
  });
};

var _default = MakePaymentButton;
exports.default = _default;